import React, { useState } from 'react';

import { layouts, displayLayouts, buttonIds } from 'components/FreecodePage/FreecodeLayout/FreecodeLayoutConstants';
import { useFreecodeContextLayout } from 'hooks/useContext';
import Dropdown from 'components/Dropdown/Dropdown';
import { LayoutOptionIcon } from './styles';

const icon = <LayoutOptionIcon icon="fa-solid fa-display" />;
const iconMobile = <LayoutOptionIcon icon="fa-solid fa-mobile-screen" />;
const iconLaptop = <LayoutOptionIcon icon="fa-solid fa-laptop" />;
const iconDesktop = <LayoutOptionIcon icon="fa-solid fa-desktop" />;

const defaultOptions = [
  { label: 'Auto', layout: null },
  { label: 'Small', layout: layouts.small, icon: iconMobile },
  { label: 'Default', layout: layouts.default, icon: iconLaptop },
  { label: 'Wide', layout: layouts.wide, icon: iconDesktop },
];

const getLayoutOptions = (layoutForced) =>
  defaultOptions.map((LayoutOption) => ({
    ...LayoutOption,
    icon: (
      <>
        <LayoutOptionIcon
          icon={LayoutOption.layout === layoutForced ? 'fa-regular fa-circle-dot' : 'fa-regular fa-circle'}
        />
        {LayoutOption.icon}
      </>
    ),
  }));

export default function LayoutButton() {
  const { layoutForced, setLayoutForced } = useFreecodeContextLayout();

  const [layoutOptions, setLayoutOptions] = useState(getLayoutOptions(layoutForced));

  const onChange = (option) => {
    setLayoutForced(option.layout);
    if (option.layout && displayLayouts.includes(option.layout)) {
      localStorage.setItem('fsEditor-layoutForced', option.layout);
    } else localStorage.removeItem('fsEditor-layoutForced');
    setLayoutOptions(getLayoutOptions(option.layout));
  };

  return (
    <Dropdown
      id={buttonIds.layoutDropdown}
      icon={icon}
      value="Layout"
      options={layoutOptions}
      onChange={onChange}
      width="auto"
    />
  );
}
